import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import PlusSvg from 'images/v5/icons/plus.svg';
import Button from 'layout/atoms/Button/Button';
import Loader from 'layout/atoms/Loader/Loader';
import ComponentVariant from 'layout/molecules/ComponentVariant/ComponentVariant';
import Grid from 'layout/molecules/Grid/Grid';
import { parseProductVariant } from 'parsers/specification/parseProduct';
import { fetchComponentVariants, resetVariants, selectVariantsStatus, } from 'store/componentDetailsSlice';
import { openModal } from 'store/layoutSlice';
function Variants({ modalPreview = false }) {
    const dispatch = useDispatch();
    const { t } = useTranslation(['specification', 'common']);
    const storeData = useSelector((state) => state.componentDetails);
    const { fetch } = useSelector(selectVariantsStatus);
    const componentVariants = storeData.variants.items;
    useEffect(() => {
        return () => {
            dispatch(resetVariants());
        };
    }, [dispatch]);
    useEffect(() => {
        var _a;
        if (((_a = storeData === null || storeData === void 0 ? void 0 : storeData.item) === null || _a === void 0 ? void 0 : _a.id) && fetch === 'idle') {
            dispatch(fetchComponentVariants(storeData.item.id));
        }
    }, [dispatch, storeData.item, fetch]);
    const handleAddVariant = () => {
        dispatch(openModal({ name: 'variantCreator', id: '' }));
    };
    const handleAddMultipleVariants = () => {
        dispatch(openModal({ name: 'multipleVariantsCreator' }));
    };
    if (fetch === 'loading') {
        return (React.createElement(Grid, null,
            React.createElement(Loader, null)));
    }
    return (React.createElement(React.Fragment, null,
        !modalPreview && (React.createElement("div", { style: { display: 'flex', gap: '12px' } },
            React.createElement(Button, { color: "primary", leftIcon: React.createElement(PlusSvg, null), onClick: handleAddVariant }, t('add_variant')),
            React.createElement(Button, { color: "primary", leftIcon: React.createElement(PlusSvg, null), onClick: handleAddMultipleVariants }, t('add_multiple_variants')))),
        React.createElement(Grid, null, componentVariants === null || componentVariants === void 0 ? void 0 : componentVariants.map((variant) => {
            var _a;
            const parsedVariant = parseProductVariant(variant);
            return (React.createElement(ComponentVariant, { key: variant.id, variant: parsedVariant, category: (_a = storeData === null || storeData === void 0 ? void 0 : storeData.item) === null || _a === void 0 ? void 0 : _a.category, componentModalPreview: modalPreview }));
        }))));
}
export default Variants;
